import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import StarlinkPage from './pages/StarlinkPage';
import './App.scss';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/starlink" element={<StarlinkPage />} />
      </Routes>
    </Router>
  );
};

export default App;
